import React from 'react';
import { motion } from 'framer-motion';
import { XCircleIcon } from 'lucide-react';
import { AnimatedSection } from './AnimatedSection';
const failures = [{
  title: 'La melatonina',
  text: 'Suele crear dependencia y te deja una "resaca cerebral" al despertar.'
}, {
  title: 'El Óxido de Magnesio barato',
  text: 'Tiene una absorción de apenas el 4%, actuando como un laxante en lugar de un relajante.'
}, {
  title: 'Leer o meditar sin corregir la deficiencia',
  text: 'Es como intentar apagar un incendio forestal con un vaso de agua.'
}, {
  title: 'Los rituales complejos',
  text: 'Son imposibles de mantener cuando ya estás agotada.'
}];
export function FailedSolutions() {
  return <AnimatedSection className="py-16 md:py-24 px-4 sm:px-6" style={{
    background: 'linear-gradient(180deg, #0D1330 0%, #111840 100%)'
  }} data-id="element-16">
      <div className="max-w-5xl mx-auto" data-id="element-17">
        <h2 className="font-display text-2xl md:text-3xl lg:text-4xl font-bold text-white mb-4 text-center" data-id="element-18">
          Por qué lo que has probado{' '}
          <span className="text-[#D4A853]" data-id="element-19">no funcionó</span>
        </h2>
        <p className="text-gray-400 text-center mb-12 max-w-2xl mx-auto" data-id="element-20">
          No es tu culpa. Estas soluciones populares tienen fallas
          fundamentales.
        </p>

        <div className="grid sm:grid-cols-2 gap-6" data-id="element-21">
          {failures.map((item, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: i * 0.1
        }} className="glass-card rounded-xl p-6 flex gap-4" data-id="element-22">
              <XCircleIcon className="w-6 h-6 text-red-400 flex-shrink-0 mt-1" data-id="element-23" />
              <div data-id="element-24">
                <h3 className="text-white font-semibold text-lg mb-2" data-id="element-25">
                  {item.title}
                </h3>
                <p className="text-gray-400 leading-relaxed" data-id="element-26">{item.text}</p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </AnimatedSection>;
}